import { Plan } from "@/app/billing/plan";
import React, { FC } from "react";

export type SubscriptionSummaryProps = {
  plan: Plan;
};

export const SubscriptionSummary: FC<SubscriptionSummaryProps> = ({ plan }) => {
  return (
    <li key={plan.id} className="flex space-x-4">
      <img
        alt={plan.name}
        src={plan.image}
        className="h-24 w-24 flex-none rounded-md bg-gray-100 object-cover object-center"
      />
      <div className="flex flex-col">
        <div className="flex-auto space-y-1">
          <h3 className="text-primary">{plan.name}</h3>{" "}
        </div>
        <p className="flex-none font-medium text-gray-900">
          {plan.description}
        </p>
      </div>
    </li>
  );
};
